import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Divider, Input, Icon, Segment, Menu } from "semantic-ui-react";
import ReactTable from "react-table";

import request from "../../utils/request";
import ResponseMessage from "../../components/common/ResponseMessage";

export const columns = [
  {
    accessor: d => (
      <Button
        as={Link}
        to={"/content-manager/jackpot/" + d.id}
        icon="edit"
        primary
      />
    ),
    id: "id",
    Header: "Action",
    filterable: false,
    sortable: false
  },
  {
    accessor: "name",
    Header: "Title"
  },
  {
    accessor: "last_modified",
    Header: "Modified",
    filterable: false
  },
  {
    id: "active",
    Header: "Active",
    filterable: false,
    sortable: false,
    accessor: d => (
      <Icon
        name={+d.active === 1 ? "check" : "close"}
        color={+d.active === 1 ? "green" : "red"}
      />
    )
  }
];

class JackpotList extends Component {
  constructor(props) {
    super(props);
    this.state = {
        isMounted: false,
        isLoading: true,
        sort: [{ id: "id", desc: true }],
        data: [],
        query: "",
        limit: 20,
        page: 1,
        total: 0,
        xhrStatus: "",
        xhrMessage: "",
        activeRSUEventId: false
    };
  }
  componentDidMount = () => {
    this.setState({ isMounted: true });
    this.fetchData();
    this.getActiveEvent();
  };
  getActiveEvent = () => { // fetch active rsu event
    return request
      .get(this, 'api:/web/jackpot-event')
      .then(resp => {
            this.setState({ activeRSUEventId: resp[0]?.id ?? false });
      });
  }
  fetchData = e => {
    this.setState({ isLoading: true });
    request
      .list(this, "api:/content/jackpot-screen", {
        sort: this.state.sort,
        q: this.state.query,
        page: this.state.page,
        limit: this.state.limit
      })
      .then(resp => {
        this.setState({
          isLoading: false,
          data: resp.data,
          total: Math.ceil(resp.total / this.state.limit)
        });
      });
  };
  handleChange = (e, { name, value }) => {
    this.setState({ query: value });
  };
  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.fetchData();
    }
  };
  handleSearch = e => {
    this.setState({ page: 1 });
    setTimeout(this.fetchData, 200);
  };
  reloadJackpot = () => { // trigger active rsu event jackpot kiosk reload
    request.get(this, `api:/event/${this.state.activeRSUEventId}/reload-jackpot`).then(resp => {
      this.setState({ xhrStatus: resp.status, xhrMessage: resp.message });
    });
  };
  render() {
    const { data, limit, isLoading, xhrStatus, xhrMessage } = this.state;
    return (
      <Segment basic>
        <Menu secondary stackable>
          <Menu.Item>
            <Input
              icon="search"
              iconPosition="left"
              action={<Button content="Search" onClick={this.handleSearch} />}
              placeholder="Search..."
              onChange={this.handleChange}
              onKeyPress={this.handleKeyPress}
            />
          </Menu.Item>
          <Menu.Menu position='right'>
            <Menu.Item>
                <Button
                    primary
                    icon="refresh"
                    content="Reload Jackpot"
                    onClick={this.reloadJackpot}
                    fluid
                />
            </Menu.Item>
            <Menu.Item>
              <Button
                    as={Link}
                    to={"/content-manager/jackpot/create"}
                    icon="tv"
                    content="New Jackpot Screen"
                    primary
                    fluid
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        <Divider hidden />
        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight"
          loading={isLoading} // Display the loading overlay when we need it
          resizable
          filterable
          defaultPageSize={limit}
          defaultSorted={[{ id: "name", desc: false }]}
          minRows={0}
        />
        <ResponseMessage status={xhrStatus} message={xhrMessage} />
      </Segment>
    );
  }
}

export default JackpotList;
